import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://plateforme.fhcgroupesarl.com/api';
const token = () => localStorage.getItem('fhc_token');

const GenerationCodeModule = () => {
  const [codeJour, setCodeJour] = useState('');
  const [dateTargeted, setDateTargeted] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().slice(0, 10);
  });
  const [message, setMessage] = useState(null);

  const todayStr = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    // Charger le code du jour depuis l'API
    fetch(`${API}/pointage/code-jour`, {
      headers: { Authorization: `Bearer ${token()}` }
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.code) setCodeJour(data.code); })
      .catch(() => {});
  }, []);

  const genererCode = () => {
    fetch(`${API}/pointage/generer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token()}`
      },
      body: JSON.stringify({ date: dateTargeted })
    })
      .then(r => r.json())
      .then(data => {
        if (data.code) {
          if (dateTargeted === todayStr) setCodeJour(data.code);
          setMessage({
            type: 'success',
            text: `✅ Code généré pour le ${new Date(dateTargeted).toLocaleDateString('fr-FR')}: ${data.code}`
          });
          navigator.clipboard.writeText(data.code).catch(() => {});
        } else {
          setMessage({ type: 'error', text: data.message || 'Erreur lors de la génération' });
        }
      })
      .catch(() => setMessage({ type: 'error', text: 'Erreur de connexion au serveur' }));
  };

  return (
    <div style={{
      background: '#111f30',
      border: '1px solid rgba(255,255,255,0.06)',
      borderRadius: 12,
      padding: 20,
      marginBottom: 20
    }}>
      <div style={{
        fontSize: 14,
        fontWeight: 600,
        color: '#C9A84C',
        marginBottom: 4
      }}>
        🔐 Génération Code de Pointage
      </div>
      <div style={{ fontSize: 11, color: '#667', marginBottom: 16 }}>
        Générez un code unique pour que les employés marquent leur présence
      </div>

      {/* Code du jour actuel */}
      {codeJour && (
        <div style={{
          background: 'rgba(201,168,76,0.12)',
          border: '1px solid rgba(201,168,76,0.3)',
          borderRadius: 10,
          padding: 16,
          marginBottom: 16
        }}>
          <div style={{ fontSize: 10, color: '#889', marginBottom: 6 }}>
            CODE DU JOUR ({new Date().toLocaleDateString('fr-FR')})
          </div>
          <div style={{
            fontSize: 32,
            fontWeight: 700,
            color: '#C9A84C',
            letterSpacing: 4,
            fontFamily: 'monospace',
            textAlign: 'center',
            marginBottom: 8
          }}>
            {codeJour}
          </div>
          <div style={{ fontSize: 10, color: '#667', textAlign: 'center' }}>
            Communiquez ce code aux employés pour le pointage
          </div>
        </div>
      )}

      {/* Génération nouveau code */}
      <div style={{
        background: 'rgba(255,255,255,0.02)',
        border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: 10,
        padding: 16
      }}>
        <div style={{ marginBottom: 12 }}>
          <label style={{
            fontSize: 10,
            color: '#889',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            display: 'block',
            marginBottom: 6
          }}>
            Date cible
          </label>
          <input
            type="date"
            value={dateTargeted}
            onChange={(e) => setDateTargeted(e.target.value)}
            style={{
              width: '100%',
              background: 'rgba(255,255,255,0.05)',
              border: '1.5px solid rgba(255,255,255,0.1)',
              borderRadius: 8,
              padding: '10px 12px',
              color: '#fff',
              fontSize: 13,
              outline: 'none'
            }}
          />
        </div>

        {message && (
          <div style={{
            padding: '8px 12px',
            borderRadius: 6,
            marginBottom: 12,
            fontSize: 11,
            background: message.type === 'success' 
              ? 'rgba(67,160,71,0.15)' 
              : 'rgba(229,57,53,0.15)',
            border: `1px solid ${message.type === 'success' 
              ? 'rgba(67,160,71,0.3)' 
              : 'rgba(229,57,53,0.3)'}`,
            color: message.type === 'success' ? '#66bb6a' : '#ef8080'
          }}>
            {message.text}
          </div>
        )}

        <button
          onClick={genererCode}
          style={{
            width: '100%',
            background: 'linear-gradient(135deg, #C9A84C, #8a6028)',
            border: 'none',
            borderRadius: 8,
            padding: '11px 16px',
            color: '#fff',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'opacity 0.2s'
          }}
        >
          🎲 Générer un nouveau code
        </button>
      </div>

      <div style={{
        marginTop: 16,
        fontSize: 10,
        color: '#556',
        padding: 12,
        background: 'rgba(66,165,245,0.08)',
        border: '1px solid rgba(66,165,245,0.2)',
        borderRadius: 8
      }}>
        <div style={{ fontWeight: 600, color: '#64b5f6', marginBottom: 4 }}>
          ℹ️ Comment ça marche ?
        </div>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li>Générez un code unique pour chaque jour</li>
          <li>Communiquez-le aux employés (email, WhatsApp, affichage...)</li>
          <li>Les employés entrent ce code dans leur dashboard pour pointer</li>
          <li>L'heure de validation = heure d'arrivée</li>
          <li>Retard automatique si après 8h30</li>
        </ul>
      </div>
    </div>
  );
};

export default GenerationCodeModule;
